module.exports = __webpack_public_path__ + "img/568c619.jpg";